<template>
    <PopupRouterViewDetail label="User Signature Detail" @hideMethod="onHidden" :isShowCopyData="false">

        <!-- APP_DETAIL_HEADER -->

        <b-card header="User SIgnature" class="mb-3 card-max-width">
            <b-row>
				<b-col cols="12" lg="6">
						<app-input-combobox-autocomplete :options="userInfos" optionsLabel="firstName" optionsKey="userName" label-cols-lg="12" label="User" id="fieldset-user" size="sm" :model.sync="model.userUserName" :isRequired="true" :state="validateState('userId')" :errorMessage="getErrorMessage(errorMessage.userId, 'userId')"   :selected="model.user != null ? model.user.firstName : ''" @input="getUserInfos" @change="updateData" :isUpdatable ="true" :isSelectMethodExists="true" @onSelectMethod="setSelectedUser" />
						<app-label label-cols-lg="12" size="sm" label="Name" :model="(model.user != null) ? model.user.firstName : null"  />
						<app-input-fileupload id="fieldset-signature" label-cols-lg="12"  label="Signature" size="sm" :model.sync="signature"  :currentModel="model.signature" @change="updateData" :isUpdatable ="true"/>
					</b-col>
					<b-col cols="12" lg="6">
				</b-col>

            </b-row>
        </b-card>

        <!-- END_APP_DETAIL_HEADER -->

        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </PopupRouterViewDetail>
</template>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import UserSignature from '@/models/UserSignature/UserSignature';
import UserSignatureList from '@/models/UserSignature/UserSignatureList';
import UserSignatureFilter from '@/filters/UserSignature/UserSignatureFilter';

import PopupRouterViewDetail from '@/components/PopupRouterViewDetail';

import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import UserInfo from '@/models/UserInfo/UserInfo';
import UserInfoFilter from '@/filters/UserInfo/UserInfoFilter';
import AppLabel from '@/components/AppLabel';
import AppInputFileupload from '@/components/AppInputFileupload';
import Attachment from '@/models/Core/Attachment';
import AttachmentFilter from '@/filters/Core/AttachmentFilter';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {
		AppInputComboboxAutocomplete,
		AppLabel,
		AppInputFileupload,
		PopupRouterViewDetail,
		PopupRouterView,
	},
	mixins : [validationMixin],
	validations: {
		model: {
			userId: {required},
		},
	},
	data() {
		return {
			signature: null,
			errorMessage : {
				userId: { required : "User is Required."},
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			filterUserSignature : null,
			currentUserSignaturePage : 1,
			userSignaturePageSize: 10,
			sortByUserSignature: '',
			sortDescUserSignature: '',
			userInfos: [],
			users: [],
			isUserComboLoading: false,
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
			isUserInfoComboLoading: false,
			isAttachmentComboLoading: false,
		}
	},
	methods : {
		showPopupWithMessage : async function(message) {
			const msg = this.$createElement;
			let msgNode = '';
			let result = false;
			msgNode = msg('div', { domProps: { innerHTML: '<p>'+message+'</p>' } })
			await this.$bvModal.msgBoxConfirm([msgNode], {
				title: 'Alert',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'success',
				cancelVariant: 'secondary',
				okTitle: 'Yes',
				cancelTitle: 'No',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(e=>{
				if(e){
					result = true;
				}
			});
			return result;
		},
		getUserSignature : async function(id) {
			this.isBusy = true;
			UserSignature.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();


				if(this.model.userUserName != null) {
					promises.push(
						this.getUserInfo(this.model.userUserName).then(result => { 
							return true; 
						}).catch(error => {
							this.$store.dispatch('addErrorMessageGlobal', error);
							throw error;
						})
					);
				}

				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadUserSignature = true;
			this.filterUserSignature.id = this.modelId;
			UserSignature.downloadDataDetail(this, this.filterUserSignature).then(result => {
				this.isDownloadUserSignature = false;
			}).catch(error => { this.isDownloadUserSignature = false; })
		},
		getUserSignatures : async function(input) {
			let filter = new UserSignatureFilter();
			if (input != undefined) {
				filter.User = input;
			}
			this.isUserSignatureComboLoading = true;
			UserSignature.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.userSignatures = result.data
				}
				this.isUserSignatureComboLoading = false;
			})
			.catch(error => {});
		},
		getUserInfos : async function(input) {
			let filter = new UserInfoFilter();
			if (input != undefined) {
				filter.firstName = input;
			}
			UserInfo.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.userInfos = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedUser(item) {
			if(item == undefined || item == null) {
				this.model.userUserName = null;
				this.model.user = null;
			} else {
				this.model.userUserName = item.userName;
				this.model.user = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getUserInfo : async function(id) {
			UserInfo.getData(this, id).then(result => {
				this.model.user = result;
				this.isBusy = false;
				return result;
				}).catch(error => { });
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.userSignatureInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.handleScroll();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				let promises = Array();

			if (this.signature != null) {
				let data = new FormData();
				data.append('file', this.signature);
				let _this = this;
				promises.push(this.$http.post('attachment/upload',
					data,
					{ headers: { 'Content-Type': 'multipart/form-data' } }
					).then(async function(response){
						if (response != null) {
							if (response.data != null) {
								model.signatureId = response.data.id;
								model.signature = response.data;
								_this.signature = null;
							}
						}
						return true;
					})
					.catch(error => {
						this.$store.dispatch('addErrorMessageGlobal', error);
						throw error;
					}));
			}

				Promise.all(promises).then((results) => {
					if (id != '' && id != null && id != undefined) {
						UserSignature.updateData(this, model, id).then(result => {
							this.isDataCommited = true;
							if (result) {
								this.$router.push({ name: 'usersignatureindex' });
							}
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					} else {
						UserSignature.insertData(this, model).then(result => {
							this.isDataCommited = true;
							if (result) {
								this.$router.push({ name: 'usersignatureindex' });
							}
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					}
				});
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			if (this.signature != null) {
				let data = new FormData();
				data.append('file', this.signature);
				let _this = this;
				promises.push(this.$http.post('attachment/upload',
					data,
					{ headers: { 'Content-Type': 'multipart/form-data' } }
					).then(async function(response){
						if (response != null) {
							if (response.data != null) {
								model.signatureId = response.data.id;
								model.signature = response.data;
								_this.signature = null;
							}
						}
						return true;
					})
					.catch(error => {
						this.$store.dispatch('addErrorMessageGlobal', error);
						throw error;
					}));
			}

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					UserSignature.updateDataDetail(this, model, id)
					.catch((error) => {
						this.getUserSignature(id);
					});
				}
			});
		},
		onHidden() {
			this.getUserSignatures();
		},
		resetModal(modalType) {
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
			}
		},
	},
	beforeMount() {
		this.filterUserSignature = new UserSignatureFilter();
		//this.getUserInfos();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getUserSignature(id);
			} else {
				this.modelId = id;
				this.getUserSignature(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
		isAllowSaveDraft: {
			get: function() {
				if(this.model.mainRecordId != undefined || this.model.mainRecordId != null) return false;
				return true;
			}
		}
	},
	watch : {
	},
}
</script>
